import * as React from "react";

import GenButton from "./Button";

interface GenCycleButtonProps<Value> {
  currentValue: Value;
  disabled?: boolean;
  onClick: (value: Value) => void;
  states: Array<{
    value: Value;
    nextValue: Value;
    button: {
      name: string;
      highlighted?: boolean;
      disabled?: boolean;
    }
  }>
}

export default function GenCycleButton<Value>(props: GenCycleButtonProps<Value>) {
  const currentValue = props.currentValue;
  const maybeCurrentStateObject = props.states.filter(function(state){
    return(state.value === currentValue);
  })[0];

  const currentStateObject = maybeCurrentStateObject ? maybeCurrentStateObject : props.states[0];

  const internalOnClick = () => {
    props.onClick(currentStateObject.nextValue);
  };

  return (
    <GenButton
      name={currentStateObject.button.name}
      highlighted={currentStateObject.button.highlighted}
      disabled={currentStateObject.button.disabled || props.disabled}
      onClick={internalOnClick}
    />
  );
}
